import { setIsKountSessionId } from 'tradera/apps/login/state/reducer';
import type { AppDispatch } from 'tradera/state/configure-store';
import { v4 as uuidv4 } from 'uuid';

export const initKountSessionId = () => async (dispatch: AppDispatch) => {
    dispatch(setIsKountSessionId(uuidv4().replace(/-/g, '')));
};
